import lodash from 'lodash';

export function getTeamMemberSelection(state, allUser = false) {
    let allTeamMembers = lodash.get(state, allUser ? 'users' : 'studySettings.allTeamMembers', []);
    if (allUser) {
        allTeamMembers = lodash.values(allTeamMembers);
        allTeamMembers = allTeamMembers.filter((u) => u.isActive);
        allTeamMembers = allTeamMembers.map((user) => ({ ...user, userId: user.id }));
    }
    allTeamMembers = allTeamMembers.filter((u) => u.groups);
    const currentMonitors = lodash.get(state, 'externalUsersForStudy', []);
    const currentStudyTeams = lodash.get(state, 'studySettings.allStudyTeam', []);
    const filteredTeamMembers = lodash.differenceWith(allTeamMembers, currentStudyTeams,
        (allUser, teamMemberUser) =>
            allUser.userId === teamMemberUser.userId
    );
    return lodash.differenceWith(filteredTeamMembers, currentMonitors,
        (allUser, monitor) =>
            allUser.userId === monitor.id
    );
}

export function getUsersWithSameGroups(state) {
    const allTeamMembers = lodash.get(state, 'studySettings.allTeamMembers', []);
    const myGroups = lodash.get(state, 'me.groups', []);
    const filteredTeamMembers = lodash.filter(allTeamMembers, teamMember => {
        let currMemberGroups = lodash.get(teamMember, 'groups', []);
        currMemberGroups = currMemberGroups && currMemberGroups.map((g) => ({ displayName: g.displayName }));
        return !lodash.isEmpty(lodash.intersectionWith(myGroups, currMemberGroups, lodash.isEqual));
    });
    return filteredTeamMembers;
}

export function getSortedStudyTeamMembers(state) {
    const users = lodash.get(state, 'studySettings.studyTeam', []);
    return lodash.sortBy(users, ['studyUserType', 'displayName']);
}

export const getMultiUserListOptions = (state) => {
    const userList = getTeamMemberSelection(state);
    const uniqueGroups = lodash.compact(lodash.uniqBy(lodash.flatMap(userList, 'groups'), 'id'));
    const resultArray = uniqueGroups && lodash.map(uniqueGroups, (group) => {
        let groupUsersList = userList.filter(f => f.groups && f.groups.find(s => s.id == group.id)).map(u => ({ ...u, label: u.displayName, value: u.userId }));
        return {
            ...group,
            label: group && group.displayName + ` (${groupUsersList.length} Users)`,
            value: group && group.id,
            users: groupUsersList
        };
    });
    return resultArray;
};
